/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import { gql } from '@apollo/client';

export const GetLegalIndicatorsQuery = gql`
  query GetLegalIndicatorsQuery($effectDate: String) {
    getLegalIndicators_simulation_customer_grantees(effectDate: $effectDate) {
      PASS 
      SMIC 
    }
  }
`;

export default GetLegalIndicatorsQuery;
